<template>
  <div>
    <TableApp
      ref="tabela"
      titulo="Tarefas"
      api-url="/crm/atividades/lista"
      :fields="fields"
    >
      <template #toolbar-actions>
        <button
          class="btn btn-dark font-weight-bolder font-size-sm"
          @click="abrirModal"
        >
          Nova tarefa
        </button>
      </template>
    </TableApp>

    <b-modal
      id="crm-tarefa-modal"
      title="Nova tarefa"
      ok-title="Salvar"
      cancel-title="Cancelar"
      @ok.prevent="salvar"
    >
      <b-form-group label="Título">
        <b-form-input v-model="form.titulo" />
      </b-form-group>
      <b-form-group label="Tipo">
        <b-form-select v-model="form.tipo" :options="tipos" />
      </b-form-group>
      <b-form-group label="Vencimento">
        <b-form-input v-model="form.vencimento_em" type="datetime-local" />
      </b-form-group>
      <BuscaClienteContato
        v-model="vinculoSelecionado"
        label="Contato ou oportunidade"
        :incluir-pessoas="false"
        incluir-oportunidades
        @criar-contato="criarContatoRapido"
      />
      <b-form-group label="Descrição">
        <b-form-textarea v-model="form.descricao" rows="3" />
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import TableApp from "@/components/Table/Table2";
import BuscaClienteContato from "@/modules/CRM/components/BuscaClienteContato";
import crmService from "@/modules/CRM/services/crmService";

export default {
  name: "crm-tarefas",
  components: { BuscaClienteContato, TableApp },
  data() {
    return {
      form: this.emptyForm(),
      vinculoSelecionado: null,
      tiposTarefa: [],
      fields: [
        { label: "Título", field: "titulo", filterOptions: { enabled: true } },
        { label: "Tipo", field: "tipo", filterOptions: { enabled: true } },
        { label: "Oportunidade", field: "oportunidade" },
        { label: "Contato", field: "contato" },
        { label: "Responsável", field: "usuario" },
        { label: "Status", field: "status", filterOptions: { enabled: true } },
        { label: "Vencimento", field: "vencimento_em" },
      ],
    };
  },
  computed: {
    tipos() {
      const ativos = this.tiposTarefa.filter((tipo) => tipo.ativo !== false);
      const tipos = ativos.length
        ? ativos
        : [
            { nome: "Tarefa", chave: "tarefa" },
            { nome: "Ligação", chave: "ligacao" },
            { nome: "Reunião", chave: "reuniao" },
            { nome: "Nota", chave: "nota" },
            { nome: "Follow-up", chave: "follow_up" },
          ];

      return tipos.map((tipo) => ({
        value: tipo.chave,
        text: tipo.nome,
      }));
    },
  },
  mounted() {
    this.loadTiposTarefa();
  },
  methods: {
    emptyForm() {
      return {
        titulo: "",
        tipo: "tarefa",
        vencimento_em: null,
        descricao: "",
        id_crm_oportunidade: null,
        id_crm_contato: null,
      };
    },
    async loadTiposTarefa() {
      const { data } = await crmService.tiposTarefaConfiguracao();
      this.tiposTarefa = this.normalizeCollection(data);
    },
    abrirModal() {
      this.form = this.emptyForm();
      this.form.tipo = this.tipos.length ? this.tipos[0].value : "tarefa";
      this.vinculoSelecionado = null;
      this.$bvModal.show("crm-tarefa-modal");
    },
    async salvar() {
      if (!this.form.titulo) {
        this.$toast.error("Informe o título da tarefa.");
        return;
      }

      if (!this.vinculoSelecionado) {
        this.$toast.error("Selecione um contato ou oportunidade.");
        return;
      }

      await crmService.criarAtividade({
        ...this.form,
        id_crm_oportunidade: this.vinculoSelecionado.id_crm_oportunidade,
        id_crm_contato: this.vinculoSelecionado.id_crm_contato,
      });
      this.$toast.success("Tarefa criada com sucesso.");
      this.$bvModal.hide("crm-tarefa-modal");
      this.$refs.tabela.refresh();
    },
    async criarContatoRapido(payload) {
      const contatoPayload =
        typeof payload === "string"
          ? { nome: payload, origem_criacao_rapida: true }
          : { ...payload, origem_criacao_rapida: true };
      const { data } = await crmService.criarContato(contatoPayload);
      const contato = data.contato || data;
      this.vinculoSelecionado = {
        tipo: "contato",
        label: contato.nome,
        id_crm_contato: contato.id_crm_contato,
        id_pessoa: contato.id_pessoa || null,
        id_crm_oportunidade: null,
        raw: contato,
      };
      this.$toast.success("Contato criado e selecionado.");
    },
    normalizeCollection(data) {
      if (Array.isArray(data)) {
        return data;
      }

      if (data && Array.isArray(data.data)) {
        return data.data;
      }

      return [];
    },
  },
};
</script>
